export default class BreakpointOnly {
  constructor(breakpoint)
  {
    this.breakpoint = window.matchMedia(`(${breakpoint})`);
    this.breakpointChecker = this.breakpointChecker.bind(this);
    this.mediaChangeListener();
  }

  breakpointChecker()
  {
  }

  mediaChangeListener()
  {
    try {
      // Chrome & Firefox
      this.breakpoint.addEventListener('change', this.breakpointChecker);
    } catch (e1) {
      try {
        // Safari
        this.breakpoint.addListener(this.breakpointChecker);
      } catch (e2) {
        //
      }
    }
  }
}
